import template from './template.standalone.html'
import controller from './revisions.standalone.controller'

export default {
  template,
  restrict: 'E',
  replace: true,
  bindings: {
    storyObj: '<',
    createNewBranch: '&',
  },
  controller,
  controllerAs: 'vm',
}
